import client from '../httpClient';

const allocationSettingCsvDownloadApi = (params) => {
  return client.get('/allocation-settings/csv-download/', { params, responseType: 'arraybuffer' });
};

export default allocationSettingCsvDownloadApi;
